<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal ">
          <div class="modal-head">{{ title }}</div>
          <div class="modal-con">
            <div class="modal-txt">
              <p v-html="contents"></p>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn border-gray" @click="cancel">
                {{ cancelText }}
              </button>
              <button class="btn" @click="done">
                {{ doneText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, toRefs } from 'vue';

const props = defineProps(['data']);
const { title, contents, doneText, cancelText } = toRefs(props.data);
const { doneCallback, cancelCallback } = props.data;
const emits = defineEmits(['close']);

const on = ref(false);
const cancel = () => {
  if (cancelCallback) cancelCallback();
  close();
};
const done = () => {
  if (doneCallback) doneCallback();
  close();
};

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
